import React, { type FC } from 'react'
import { useIntl } from 'react-intl'
import {
  Button,
  Flex,
  Text,
  Title,
  TITLE_VARIANT_L,
  BUTTON_VARIANT_SECONDARY,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Spinner,
} from 'mailup-web-components'
import { useAtom } from 'jotai'
import { subscriberCountAtom } from '../state/state'
import {
  simulateSubsCallback,
  tryGoToRecipientsOrOpenModalCallback,
} from '../callbacks/form'
import { useAtomCallback } from 'jotai/utils'
import { isFormValidAtom } from '../state/validation'
import { ChannelType } from '../../../types/FilterCondition'

const RecipientsCounter: FC = () => {
  const intl = useIntl()

  const [{ count, loading }] = useAtom(subscriberCountAtom)
  const [isFormValid] = useAtom(isFormValidAtom)
  const simulateSubs = useAtomCallback(simulateSubsCallback)
  const tryGoToRecipientsOrOpenModal = useAtomCallback(
    tryGoToRecipientsOrOpenModalCallback,
  )

  return (
    <Flex flexDirection='column' gap='24px' padding='16px'>
      <Title variant={TITLE_VARIANT_L}>
        {intl.formatMessage({ id: 'Load.CombinedFilterForm.CounterTitle' })}
      </Title>
      <Text>
        {intl.formatMessage({ id: 'Load.CombinedFilterForm.CounterDesc' })}
      </Text>
      <Flex
        flexDirection='row'
        gap='24px'
        alignItems='center'
        justifyContent='space-between'
      >
        <Text>
          {intl.formatMessage({ id: 'Load.Common.EmailSubscribers' })}
        </Text>
        {loading && <Spinner />}
        {!loading &&
          (count.Email !== undefined && isFormValid ? (
            <Link
              variant={LINK_VARIANT_HIGHLIGHT}
              onClick={() => {
                tryGoToRecipientsOrOpenModal(ChannelType.Email)
              }}
            >
              {count.Email}
            </Link>
          ) : (
            <Text>-</Text>
          ))}
      </Flex>
      <Flex
        flexDirection='row'
        gap='24px'
        alignItems='center'
        justifyContent='space-between'
      >
        <Text>{intl.formatMessage({ id: 'Load.Common.SmsSubscribers' })}</Text>
        {loading && <Spinner />}
        {!loading &&
          (count.Sms !== undefined && isFormValid ? (
            <Link
              variant={LINK_VARIANT_HIGHLIGHT}
              onClick={() => {
                tryGoToRecipientsOrOpenModal(ChannelType.Sms)
              }}
            >
              {count.Sms}
            </Link>
          ) : (
            <Text>-</Text>
          ))}
      </Flex>
      <Flex flexDirection='row' justifyContent='end'>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test='filterForm-Calculate'
          onClick={simulateSubs}
          disabled={loading || !isFormValid}
        >
          {intl.formatMessage({ id: 'Load.Common.Calculate' })}
        </Button>
      </Flex>
    </Flex>
  )
}

export default RecipientsCounter
